import api from "../../config/api";

const state = {
    menuData: ""
}
const mutations = {
    SET_MENU_DATA(state, payload) {
        state.menuData = payload;
    }
}

const actions = {
    async fetchMenuData({ commit }, locationID) {
        try {
            await api.post('/personajax', {
                cmd: "getmenu",
                locationid: locationID
            }).then((response) =>
                commit('SET_MENU_DATA', response.data)
            ).catch((error) => {
                console.error('Error fetching API data:', error);
            })
        } catch (error) {
            console.error('Error fetching API data:', error);
        }
    },
}

const getters = {
    // stMenuData: state => state.menuData,
}

export default {
    state,
    mutations,
    actions,
    getters
}